export default "__VITE_ASSET__dd8f7c1f__"